/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useEffect, useState } from 'react';

import { Flex, If } from '@cleartax/zoids';
import { useHistory } from 'react-router-dom';
import { track } from '../../analytics/analytics';
import { EventIDs } from '../../analytics/events';
import {
  BAD_COLOR,
  BAD_GREY,
  GREAT_COLOR,
  GREAT_GREY,
  OKAY_COLOR,
  OKAY_GREY,
} from '../../constants/urls';
import { useGlobalState } from '../context/qrState';
import { UserContext } from '../context/userContext';
import {
  Container,
  FeedbackText,
  EmojiContainer,
  EmojiText,
  Emoji,
  Input,
  FeedbackTextLength,
  Footer,
  SubmitBtn,
  CheckBox,
  OptionsText,
  CheckMark,
  CheckContainer,
} from './styles';
import { FeedbackMap, FdbkStatus } from './types';

const Feedback = () => {
  // eslint-disable-next-line no-unused-vars
  const [showSuccessLayout, setShowSuccessLayout] = useGlobalState(
    'feedBackSuccess'
  );
  const { businessDetails, email } = useContext<Record<string, any>>(
    UserContext
  );
  const [selectedEmoji, setSelectedEmoji] = useState('');
  const [feedback, setFeedback] = useState('');
  const feedBackOptions = {
    item1: false,
    item2: false,
    item3: false,
    item4: false,
  };
  const [fdbkOptions, setFdbkOptions] = useState(feedBackOptions);
  const history = useHistory();

  useEffect(() => {
    businessDetails.addPageName('FEEDBACK');
    const payload = {
      email,
    };
    track(EventIDs.FEEDBACK_PAGE, payload);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const payload = {
      email,
    };
    if (selectedEmoji === FdbkStatus.BAD) {
      track(EventIDs.BAD, payload);
      // @ts-ignore
      document.querySelector('#BAD').height = 48;
      // @ts-ignore
      document.querySelector('#BAD').width = 48;
    } else if (selectedEmoji === FdbkStatus.OKAY) {
      track(EventIDs.OKAY, payload);
      // @ts-ignore
      document.querySelector('#OKAY').height = 48;
      // @ts-ignore
      document.querySelector('#OKAY').width = 48;
    } else if (selectedEmoji === FdbkStatus.GREAT) {
      track(EventIDs.GREAT, payload);
      // @ts-ignore
      document.querySelector('#GREAT').height = 48;
      // @ts-ignore
      document.querySelector('#GREAT').width = 48;
    }
    const timer = setTimeout(() => {
      if (selectedEmoji === FdbkStatus.BAD) {
        // @ts-ignore
        document.querySelector('#BAD').height = 52;
        // @ts-ignore
        document.querySelector('#BAD').width = 52;
      } else if (selectedEmoji === FdbkStatus.OKAY) {
        // @ts-ignore
        document.querySelector('#OKAY').height = 52;
        // @ts-ignore
        document.querySelector('#OKAY').width = 52;
      } else if (selectedEmoji === FdbkStatus.GREAT) {
        // @ts-ignore
        document.querySelector('#GREAT').height = 52;
        // @ts-ignore
        document.querySelector('#GREAT').width = 52;
      }
    }, 100);
    setFdbkOptions(feedBackOptions);
    setFeedback('');
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEmoji]);

  const submitFeedback = () => {
    const payload = {
      email,
      status: '',
      feedBackOptions: '',
      feedback: '',
    };

    if (selectedEmoji) {
      payload.status = selectedEmoji;
    }

    if (feedback.length !== 0) {
      payload.feedback = feedback;
    }

    if (Object.values(fdbkOptions).includes(true)) {
      const choosenOptionsList: string[] = [];

      Object.values(fdbkOptions).forEach((value, index) => {
        if (value) {
          if (index === 3 && selectedEmoji === FdbkStatus.GREAT) {
            choosenOptionsList.push('Easy to use');
          } else {
            // @ts-ignore
            choosenOptionsList.push(`${FeedbackMap.get(index + 1)}`);
          }
        }
      });
      payload.feedBackOptions = choosenOptionsList.join(', ');
    }

    track(EventIDs.SEND_FEEDBACK, payload);
    history.goBack();
    setShowSuccessLayout(true);
  };

  const handleCheckboxClick = (n: number) => {
    const payload = {
      email,
      feedback: FeedbackMap.get(n),
    };

    track(EventIDs.CHOOSE_FEEDBK_OPTION, payload);

    let options = { ...fdbkOptions };

    switch (n) {
      case 1:
        options = {
          ...fdbkOptions,
          item1: !fdbkOptions.item1,
        };
        break;
      case 2:
        options = {
          ...fdbkOptions,
          item2: !fdbkOptions.item2,
        };
        break;
      case 3:
        options = {
          ...fdbkOptions,
          item3: !fdbkOptions.item3,
        };
        break;
      case 4:
        options = {
          ...fdbkOptions,
          item4: !fdbkOptions.item4,
        };
        break;
    }
    setFdbkOptions(options);
  };
  return (
    <>
      <Container>
        <FeedbackText>
          Tell us how you feel about Cleartax
          <br />
          E-invoicing App
        </FeedbackText>
        <EmojiContainer>
          <Flex
            flexDirection="column"
            justifyContent="space-between"
            alignItems="center"
          >
            <Emoji>
              <img
                id="BAD"
                src={selectedEmoji === FdbkStatus.BAD ? BAD_COLOR : BAD_GREY}
                alt=""
                width="52px"
                height="52px"
                onClick={() => setSelectedEmoji(FdbkStatus.BAD)}
              />
            </Emoji>
            <EmojiText>Bad</EmojiText>
          </Flex>
          <Flex
            flexDirection="column"
            justifyContent="space-between"
            alignItems="center"
          >
            <Emoji>
              <img
                id="OKAY"
                src={selectedEmoji === FdbkStatus.OKAY ? OKAY_COLOR : OKAY_GREY}
                alt=""
                width="52px"
                height="52px"
                onClick={() => setSelectedEmoji(FdbkStatus.OKAY)}
              />
            </Emoji>
            <EmojiText>Okay</EmojiText>
          </Flex>
          <Flex
            flexDirection="column"
            justifyContent="space-between"
            alignItems="center"
          >
            <Emoji>
              <img
                id="GREAT"
                src={
                  selectedEmoji === FdbkStatus.GREAT ? GREAT_COLOR : GREAT_GREY
                }
                alt=""
                width="52px"
                height="52px"
                onClick={() => setSelectedEmoji(FdbkStatus.GREAT)}
              />
            </Emoji>
            <EmojiText>Great</EmojiText>
          </Flex>
        </EmojiContainer>
        <If condition={selectedEmoji !== ''}>
          <FeedbackText style={{ marginTop: '34px' }}>
            {selectedEmoji === FdbkStatus.GREAT
              ? `We’re glad! What did you like?`
              : `What can we improve?`}
          </FeedbackText>
          <Flex
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
            marginLeft="5%"
            marginTop="16px"
          >
            <CheckContainer>
              <CheckBox
                onClick={() => handleCheckboxClick(1)}
                checked={fdbkOptions.item1}
              />
              <CheckMark checked={fdbkOptions.item1} />
            </CheckContainer>
            <OptionsText onClick={() => handleCheckboxClick(1)}>
              {FeedbackMap.get(1)}
            </OptionsText>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            marginLeft="5%"
            marginTop="16px"
          >
            <CheckContainer>
              <CheckBox
                onClick={() => handleCheckboxClick(2)}
                checked={fdbkOptions.item2}
              />
              <CheckMark checked={fdbkOptions.item2} />
            </CheckContainer>
            <OptionsText onClick={() => handleCheckboxClick(2)}>
              {FeedbackMap.get(2)}{' '}
            </OptionsText>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            marginLeft="5%"
            marginTop="16px"
          >
            <CheckContainer>
              <CheckBox
                onClick={() => handleCheckboxClick(3)}
                checked={fdbkOptions.item3}
              />
              <CheckMark checked={fdbkOptions.item3} />
            </CheckContainer>
            <OptionsText onClick={() => handleCheckboxClick(3)}>
              {FeedbackMap.get(3)}
            </OptionsText>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            marginLeft="5%"
            marginTop="16px"
            marginBottom="24px"
          >
            <CheckContainer>
              <CheckBox
                onClick={() => handleCheckboxClick(4)}
                checked={fdbkOptions.item4}
              />
              <CheckMark checked={fdbkOptions.item4} />
            </CheckContainer>
            <OptionsText onClick={() => handleCheckboxClick(4)}>
              {selectedEmoji === FdbkStatus.GREAT
                ? `Easy to use`
                : FeedbackMap.get(4)}
            </OptionsText>
          </Flex>
        </If>
        <FeedbackText style={{ marginTop: '20px' }}>
          Any thoughts you’d like to share?
        </FeedbackText>
        <Input
          maxLength={500}
          value={feedback}
          onChange={(e: any) => setFeedback(e.target.value?.slice(0, 500))}
        />
        <FeedbackTextLength>{feedback.length}/500</FeedbackTextLength>
        <Footer>
          <SubmitBtn
            onClick={submitFeedback}
            disabled={
              !Object.values(fdbkOptions).includes(true) &&
              !(selectedEmoji || feedback)
            }
          >
            Send Feedback
          </SubmitBtn>
        </Footer>
      </Container>
    </>
  );
};

export default Feedback;
